import { createAction, props } from '@ngrx/store';
import { UsersResponse } from '../../../api/models/user.model';


export const getUsersAction = createAction(
    '[Users] Get Users list',
        props<{  searchString: string, pagination:any}>()
);

export const searchUsersAction = createAction(
    '[Users] Search Users list',
        props<{ searchString: string, pagination:any}>()
);

export const setUsersAction = createAction(
    '[Users] Set Users list',
    props<{ users: UsersResponse, searchString: string}>()
);

export const setUsersActionFail = createAction(
    '[Users] Set Users list failed',
    props<{ error:any}>()
);

export const clearUsersAction = createAction(
    '[Users] Clear Users list'
);

export const clearUserSearchStringAction = createAction(
    '[Users] Clear Users SearchString'
);

export const usersActionTypes = {
    getUsersAction,
    searchUsersAction,
    setUsersAction,
    setUsersActionFail,
    clearUsersAction,
    clearUserSearchStringAction
}

